export default __webpack_public_path__ + "static/10_24-976ec0f9f5a6bd9942976225130785d8.png";